(function(){
    window._xdf_tpa_app_function_register_map = {}
    window._xdf_tpa_app_function_listener = function(methodName,...args){
        // console.log(111112222,methodName,args)
        const func = window._xdf_tpa_app_function_register_map[methodName];
        func && func(...args);
    }
})()
